/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import { memo, useMemo } from 'react';
import { Box } from '@mui/system';
import { AspyreDatePicker as DatePicker } from 'components/common/InputFields';
import {
    Button,
    Grid,
    Stack,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Pagination,
    Autocomplete,
    CircularProgress,
    InputAdornment,
    IconButton
} from '@mui/material';

import useAuth from 'hooks/useAuth';
import useSnackbar from 'hooks/useSnackbar';
import { GLOBAL_DATE_FORMAT, CLASS, GLOBAL_DATE_TIME_FORMAT } from 'constant';
import usePermission from 'hooks/usePermission';
import moment from 'moment';
import * as React from 'react';
import ExportColumnData from 'components/ExportColumnData';
import NoData from 'components/reusable/NoData';
import { LocationDropdown } from 'components/reusable/Dropdowns';
import AmountCard from 'components/reusable/AmountCard';
import _ from 'lodash';
import { useGetSessionClassroomsQuery } from 'store/services/school/classroom';
import { utcToLocal } from 'utils/time-conversion';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import { downloadFile } from 'utils/file';
import { MonthPicker } from '@mui/x-date-pickers';
import CloseIcon from '@mui/icons-material/Close';

const MonthlyReport = ({
    formik,
    monthlyReportData,
    monthlyReportLoading,
    setPage,
    page,
    download,
    downloadLoading,
    setMonthlyReportData
}) => {
    const service = CLASS.eidt;
    const ROWS_PER_PAGE = 15;

    const { user } = useAuth();
    const { notify } = useSnackbar();
    const { hasPermission } = usePermission();

    const {
        data: classrooms,
        isLoading: classroomLoading,
        isFetching: classroomFetching
    } = useGetSessionClassroomsQuery(
        {
            filters: {
                ...(user?.client_id && { client_id: user.client_id }),
                ...(formik?.values?.location && { location_id: [formik?.values?.location?.id] })
            }
        },
        {
            skip: !formik?.values?.location
        }
    );

    const sortedClassrooms = useMemo(() => {
        return [...(classrooms?.fields || [])].sort((a, b) => a.location.name.toLowerCase().localeCompare(b.location.name.toLowerCase()));
    }, [classrooms]);

    const handleResetForm = () => {
        formik.resetForm();
        setMonthlyReportData(null);
    };

    const handleDownload = async () => {
        try {
            const selectedDate = new Date(formik.values.month); // this is a Date object
            const startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1, 0, 0, 0);
            const endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0, 23, 59, 59);
            const res = await download({
                filters: {
                    client_id: user?.client_id,
                    location_id: formik.values?.location?.id,
                    service: formik.values.location?.location_type?.location_type === 'EIDT' ? CLASS.eidt : CLASS.addt,
                    // status: values?.status?.id,
                    ...(formik.values?.student && { student_name: formik.values?.student }),
                    ...(formik.values?.classroom && { class_room_id: formik.values?.classroom?.id }),
                    start_date: moment(new Date(startOfMonth)).startOf('day').format('YYYY-MM-DD HH:mm'),
                    end_date: moment(new Date(endOfMonth)).endOf('day').format('YYYY-MM-DD HH:mm'),
                    is_download: 1
                }
            }).unwrap();
            downloadFile(res?.blob, res?.fileName);
        } catch (error) {
            notify({
                message: 'Error downloading report',
                severity: 'error'
            });
        }
    };

    const totalDaysInMonth = useMemo(() => {
        return formik?.values?.month ? formik.values.month.daysInMonth() : 31;
    }, [formik?.values?.month]);

    const generateTabularData = useMemo(() => {
        if (!monthlyReportData?.fields?.length) return null;

        const presentCouns = monthlyReportData?.fields.map((item) => {
            return item.present_count_per_day;
        });
        // Step 1: Parse and flatten
        const allCounts = presentCouns.flatMap((item) => {
            try {
                return JSON.parse(item);
            } catch (e) {
                console.error('Invalid JSON string:', item);
                return [];
            }
        });

        const dayMeta = Array.from({ length: totalDaysInMonth }, (_, i) => {
            const date = formik.values.month.clone().date(i + 1);
            const dayOfWeek = date.day(); // Sunday = 0, Saturday = 6
            console.log('dayOfWeek::', dayOfWeek);

            const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
            return { day: i + 1, isWeekend };
        });

        return (
            <>
                <TableContainer>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ minWidth: 180 }}>Patient Name</TableCell>
                                <TableCell align="center" sx={{ minWidth: 180 }}>
                                    Classroom
                                </TableCell>
                                <TableCell align="center" sx={{ minWidth: 180 }}>
                                    Present Count
                                </TableCell>
                                {Array.from({ length: totalDaysInMonth }, (_, i) => {
                                    const currentDate = formik.values.month.clone().date(i + 1);
                                    const dayOfWeek = currentDate.day(); // 0 = Sunday, 6 = Saturday
                                    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

                                    // Get count for this specific day
                                    const matchedCountEntry = allCounts.find(
                                        (entry) => moment(entry?.present_dates, 'MM/DD/YYYY').date() === i + 1
                                    );
                                    const count = matchedCountEntry ? matchedCountEntry.count : 0;

                                    return (
                                        <TableCell
                                            key={i + 1}
                                            align="center"
                                            sx={{
                                                backgroundColor: isWeekend ? '#f0f0f0' : undefined,
                                                fontWeight: isWeekend ? 'bold' : undefined
                                            }}
                                        >
                                            <div>{i + 1}</div>
                                            <div style={{ fontSize: '0.75rem', color: 'gray' }}>
                                                {count}/{monthlyReportData?.fields?.[0]?.total_count}
                                            </div>
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {monthlyReportData?.fields?.map((patient) => {
                                const dayArray = JSON.parse(patient?.present_dates).map((dateStr) =>
                                    moment(dateStr, 'MM/DD/YYYY').date().toString()
                                );
                                const presentSet = new Set(dayArray);

                                return (
                                    // eslint-disable-next-line no-underscore-dangle
                                    <TableRow key={patient?._uuid}>
                                        <TableCell>{patient.patient_name}</TableCell>

                                        <TableCell align="center">{patient.classroom_name}</TableCell>
                                        <TableCell align="center">
                                            {dayArray.length}/{totalDaysInMonth}
                                        </TableCell>
                                        {dayMeta.map(({ day, isWeekend }) => {
                                            const dayStr = day.toString();
                                            const isPresent = presentSet.has(dayStr);
                                            const status = isPresent ? 'P' : 'A';
                                            const color = isPresent ? 'green' : 'red';
                                            const fontWeight = isPresent ? 'bold' : 'normal';

                                            return (
                                                <TableCell
                                                    key={day}
                                                    align="center"
                                                    sx={{
                                                        color,
                                                        fontWeight,
                                                        backgroundColor: isWeekend ? '#f9f9f9' : undefined
                                                    }}
                                                >
                                                    {status}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Stack justifyContent="flex-end">
                    <Pagination
                        color="primary"
                        count={Math.ceil((monthlyReportData?.fields?.[0]?.total_count || 1) / ROWS_PER_PAGE)}
                        page={page}
                        onChange={(_, value) => setPage(value)}
                        sx={{ mt: 3, mb: 3, '& .MuiPagination-ul': { flexWrap: 'nowrap', justifyContent: 'flex-end' } }}
                        showFirstButton
                        showLastButton
                    />
                </Stack>
            </>
        );
    }, [monthlyReportData]);

    return (
        <>
            <Grid
                container
                spacing={2}
                sx={{
                    marginTop: 0.25
                }}
            >
                {/* Date Picker */}
                <Grid item sm={12} md={2.25}>
                    <DatePicker
                        required
                        sx={{ width: '100%' }}
                        views={['year', 'month']}
                        label="Month"
                        minDate={new Date('2020-01-01')}
                        maxDate={new Date(new Date().getFullYear(), new Date().getMonth(), 1)} // Current year and month
                        value={formik.values.month}
                        onChange={(v) => formik.setFieldValue('month', v)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                error={formik.touched.month && Boolean(formik.errors.month)}
                                helperText={formik.touched.month && formik.errors.month}
                            />
                        )}
                    />
                </Grid>

                {/* Location */}
                <Grid item sm={12} md={2.25}>
                    <LocationDropdown
                        required
                        limitTags={2}
                        sx={{ width: '100%' }}
                        filters={{ is_session: true }}
                        // subType="LIST_DROPDOWN"
                        value={formik.values.location}
                        onChange={(value) => {
                            formik.setFieldValue('location', value);
                            formik.setFieldValue('classroom', null);
                        }}
                        error={formik.touched.location && Boolean(formik.errors.location)}
                        helperText={formik.touched.location && formik.errors.location}
                    />
                </Grid>

                {/* Classroom */}
                <Grid item sm={12} md={2.25}>
                    <Autocomplete
                        loading={classroomLoading || classroomFetching}
                        options={sortedClassrooms}
                        groupBy={(option) => option?.location?.name}
                        getOptionLabel={(option) => option?.name || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Classroom"
                                placeholder="Classroom"
                                error={formik.touched.classroom && Boolean(formik.errors.classroom)}
                                helperText={formik.touched.classroom && formik.errors.classroom}
                            />
                        )}
                        value={formik.values.classroom}
                        onChange={(_, newValue) => formik.setFieldValue('classroom', newValue)}
                    />
                </Grid>

                {/* Status */}

                {/* Student Search */}
                <Grid item sm={12} md={2.25}>
                    {/* <TextField
                        fullWidth
                        label="Student"
                        placeholder="Search Student"
                        value={formik.values.student}
                        onChange={(e) => formik.setFieldValue('student', e.target.value)}
                        error={formik.touched.student && Boolean(formik.errors.student)}
                        helperText={formik.touched.student && formik.errors.student}
                    /> */}

                    <TextField
                        fullWidth
                        label="Student"
                        placeholder="Search Student"
                        value={formik.values.student}
                        onChange={(e) => formik.setFieldValue('student', e.target.value)}
                        error={formik.touched.student && Boolean(formik.errors.student)}
                        helperText={formik.touched.student && formik.errors.student}
                        InputProps={{
                            endAdornment: formik.values.student && (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => formik.setFieldValue('student', '')} edge="end" size="small">
                                        <CloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    />
                </Grid>

                {/* Action Buttons */}
                <Grid item sm={12} md={3}>
                    <Stack direction="row" spacing={2} sx={{ minHeight: 50 }}>
                        <Button
                            onClick={() => {
                                setPage(1);
                                formik.handleSubmit();
                            }}
                            variant="contained"
                        >
                            Search
                        </Button>
                        <Button onClick={handleResetForm} variant="contained">
                            Reset
                        </Button>
                        {monthlyReportData?.fields?.length > 0 && hasPermission(['attendance_report_download']) && (
                            <ExportColumnData handleDownload={handleDownload} betaBtn />
                        )}
                    </Stack>
                </Grid>
            </Grid>

            {/* Cards */}

            {/* Loader */}
            <Stack flexDirection="row" justifyContent="center" mt={1}>
                {(monthlyReportLoading || downloadLoading) && <CircularProgress />}
            </Stack>

            {/* Table / No Data */}
            {!monthlyReportData?.fields?.length ? <NoData title="No Data Found." /> : <Box>{generateTabularData}</Box>}
        </>
    );
};

export default memo(MonthlyReport);
